import { encode } from '..';
export const blockquote = (node, {
  context
} = {}) => {
  const result = [];
  node.forEach(n => {
    result.push(encode(n, context));
  });
  return `{quote}${result.join('\n\n')}{quote}`;
};